export default __webpack_public_path__ + "assets/d6ab6cfa72c32d5e44312f9a847f7cfe.jpg";